import {type BskyAgent} from '@atproto/api'

import {wsocFetch, WsocFetchError, xrpcPath} from '#/lib/wsoc/fetch'
import {type VerificationDetails} from './types'

/**
 * Fetch verification details for any account by DID.
 * Unauthenticated — no agent required.
 *
 * Returns null when the account has no active verification (HTTP 400 NotVerified).
 *
 * @throws WsocFetchError on any other failure
 */
export async function getVerificationDetails(
  agent: BskyAgent,
  did: string,
  options?: {signal?: AbortSignal},
): Promise<VerificationDetails | null> {
  const accessJwt = agent.session?.accessJwt
  if (!accessJwt) {
    throw new Error('getVerificationDetails: no active session')
  }
  const path =
    xrpcPath('eu.wsocial.actor.getVerificationDetails') +
    `?did=${encodeURIComponent(did)}`
  try {
    return await wsocFetch<VerificationDetails>(path, {
      method: 'GET',
      signal: options?.signal,
      accessJwt,
    })
  } catch (err) {
    if (
      err instanceof WsocFetchError &&
      err.status === 400 &&
      err.code === 'NotVerified'
    ) {
      return null
    }
    throw err
  }
}
